/**
 * Breadcrumbs localization strings
 * @module breadcrumbsLang
 */

const breadcrumbsLang = {
  start: 'Начало',
  releases: 'Издания',
  alphanumeric: 'По азбучен ред',
  genres: 'По стил',
  years: 'По години',
  regions: 'По региони',
  bands: 'Групи',
  albums: 'Албуми',
  artists: 'Музиканти',
  help: 'Помощ',
  labels: 'Издатели',
  api: 'API'
}

export default breadcrumbsLang



// WEBPACK FOOTER //
// ./src/helpers/breadcrumbs-lang.js